var utils = require('../../../lib/utils');

module.exports = {
	config: {
		focusAble: true
	},

	model: {
		fieldCode: 'time-range-picker',
		dataJSON: {
			// from: '08:00',
			// to: '17:00'
		},
		absolutes: {
			fromTIME: 0,
			toTIME: 0
		},
		isActivated: false,
		config: {
			separatedFieldCodes: {
				fromTIME: 'from',
				toTIME: 'to'
			},
			isOptional: true,
			time: {
				defaultFromTIME: '',
				defaultToTIME: '',
				timeParts: ['hours', 'minutes'], // ['hours', 'minutes', 'seconds', 'milliseconds']
				timeRange: {
					// min: '08:30:00.000',
					// max: '17:00:00.000'
				},
				maxExclusive: false,
				hours: {
					stepSize: 1,
					beforeSymbol: ''
				},
				minutes: {
					stepSize: 15,
					beforeSymbol: ':'
				}
			}
		}
	},

	events: {
		onChange: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target;
				var fieldCode;
				var value;
				if(
					($target = $(event.target)).length > 0
					&&
					(fieldCode = $target.data('fieldCode'))
					&&
					(value = $target.val()) !== undefined
				){
					if(fieldCode === 'activated'){
						value = $target.is(':checked');
					}
					event.data.component.change({
						fieldCode: fieldCode,
						value: value
					});
				}
			}
		},

		getFocus: {
			type: 'click',
			action: function(event) {
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				if(self.model.config.isOptional){
					var $activationCheckbox;
					if(!$(event.target).is('[data-field-code="activated"]') && ($activationCheckbox = self.$.find('[data-field-code="activated"]')).length > 0){
						self.model.isActivated = !$activationCheckbox.prop('checked');
						$activationCheckbox.prop('checked', self.model.isActivated);
						self.change({
							fieldCode: 'activated',
							value: self.model.isActivated
						});
					}
				}
			}
		}
	},

	methods: {
		change: function(options){
			var optionalChanged = false;
			var foreignFieldCode;

			if(this.model.config.isOptional && options.fieldCode === 'activated'){
				optionalChanged = true;
				this.model.isActivated = options.value;
			} else if((foreignFieldCode = this.model.config.separatedFieldCodes[options.fieldCode])){
				this.model.dataJSON[foreignFieldCode] = options.value;
				this.model.absolutes[options.fieldCode] = (options.additionals || {}).absoluteTime || 0;
				if(this.model.absolutes.fromTIME > this.model.absolutes.toTIME && this.model.timePickerComponents){
					if(options.fieldCode === 'toTIME'){
						this.model.timePickerComponents.fromTIME.setTime(options.value);
					} else {
						this.model.timePickerComponents.toTIME.setTime(options.value);
					}
				}
			}

			// change necessary?
			if(!this.model.config.isOptional || optionalChanged || this.model.isActivated){
				var options = {
					fieldCode: this.model.fieldCode,
					value: this.model.dataJSON
				};
				var tpc;
				if(this.model.config.isOptional){
					if(this.model.isActivated){
						if(optionalChanged){
							this.$.removeClass('disabled');
							for(tpc in this.model.timePickerComponents){
								this.model.timePickerComponents[tpc].enable();
							}
						}
					} else {
						if(optionalChanged){
							this.$.addClass('disabled');
							for(tpc in this.model.timePickerComponents){
								this.model.timePickerComponents[tpc].disable();
							}
						}

						options = {
							fieldCode: this.model.fieldCode,
							value: this.model.config.emptyDataJSON
						};
					}
				}

				// tell parent form that this field(s) has been changed
				this.parent(function(parentComponent){
					parentComponent.trigger('onChildChanged', options);
				});
			}
		}
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.timePickerComponents){
				this.model.timePickerComponents = {};
				this.find('base_form_fields_time-picker', function(timePickerComponent){
					this.model.timePickerComponents[timePickerComponent.model.fieldCode] = timePickerComponent;
				});
			}
			
			if(!options.refresh){
				var time;

				if(utils.collectionSize(this.model.dataJSON) > 0 && this.model.config.isOptional){
					this.model.isActivated = true;
				}

				this.model.config.emptyDataJSON = {};

				var separatedFieldCodes = this.model.config.separatedFieldCodes;
				var fC, foreignFieldCode;
				for(fC in separatedFieldCodes){
					foreignFieldCode = separatedFieldCodes[fC];
					this.model.config.emptyDataJSON[foreignFieldCode] = null;

					if(this.model.timePickerComponents[fC]){
						time = this.model.timePickerComponents[fC].getTime();
						this.model.dataJSON[foreignFieldCode] = time.value;
						this.model.absolutes[fC] = time.absoluteValue;
					}
				}
			}
		},

		onChildChanged: function($element, options){
			this.change(options);
		}
	}
};